/** Wygeneruj zdarzenie dla przycisku logowania */
export const dispatch = (name, details, logInButton) => {
    const event = new CustomEvent(name, {
        detail: details,
        bubbles: true,
        composed: true,
    });
    logInButton?.dispatchEvent(event);
};
